import { Expose, Type } from "class-transformer";
import { IsArray, IsBoolean, IsString, ValidateNested } from "class-validator";
import { Permission } from "@/models/api/administration/roles/Permission";

export class PermissionGroupItem extends Permission {
  @Expose()
  @IsBoolean()
  isActive!: boolean;
}

export class PermissionGroup {
  @Expose()
  @IsString()
  groupName!: string;
  @Expose()
  @Type(() => PermissionGroupItem)
  @IsArray()
  @ValidateNested()
  permissions!: Array<PermissionGroupItem>;
}
